module.exports = __webpack_public_path__ + "static/LindaNguyen-de1293f73a2b013c62f20570ffd3d0b0.jpg";